import { useState, useCallback } from "react";
import { UrlApi } from "../../../services/apirest";

export const useDocuments = (initialDocuments = []) => {
  const [documents, setDocuments] = useState(initialDocuments);

  const ViewFiles = async (archivo, extension) => {
    let response;
    let blobUrl;

    if (extension === "pdf" || extension === "application/pdf") {
      response = await fetch(UrlApi + "/uploadfiles/uploadspdf/" + archivo);
    } else {
      response = await fetch(UrlApi + "/uploadfiles/uploads/" + archivo);
    }

    blobUrl = URL.createObjectURL(await response.blob());

    // abrir inmediatamente en el click del usuario
    window.open(blobUrl, "_blank", "noreferrer");
  };
  const removeDocument = async (id, archive) => {
    if (window.confirm("Seguro de borrar el archivo " + archive)) {
      try {
        await fetch(UrlApi + "/uploadfiles/todownload/" + id, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        });
      } catch (error) {
        console.error("Error al eliminar el documento:", error);
      }
    }
  };
  const getDocuments = useCallback(async (fileId, tipo) => {
    console.log("Fetching documents for fileId:", fileId, "and type:", tipo);

    try {
      const response = await fetch(
        `${UrlApi}/mp_documentacion/get/${fileId}/${tipo}`
      );
      const data = await response.json();
      setDocuments(data);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  }, []);
  return {
    removeDocument,
    ViewFiles,
    getDocuments,
    documents,
  };
};
